var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBusinessLoan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28983_23765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6768 15.4298C22.2168 15.4298 21.843 15.0351 21.843 14.5492V13.0099H18.5093V14.5506C18.5093 15.0364 18.1368 15.4312 17.6755 15.4312C17.2155 15.4312 16.8418 15.0364 16.8418 14.5506V13.0099C16.8418 12.0395 17.5893 11.25 18.508 11.25H21.8418C22.7605 11.25 23.508 12.0395 23.508 13.0099V14.5506C23.5105 15.0364 23.138 15.4298 22.6768 15.4298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8693 20.2713H20.503C21.4768 20.2713 22.2693 21.1083 22.2693 22.1367C22.2693 23.0622 21.638 23.8227 20.8105 23.9785V24.6716C20.8105 25.036 20.5305 25.3317 20.1855 25.3317C19.8405 25.3317 19.5605 25.036 19.5605 24.6716V24.0115H18.7268C18.3818 24.0115 18.1018 23.7157 18.1018 23.3514C18.1018 22.987 18.3818 22.6912 18.7268 22.6912H20.5018C20.7868 22.6912 21.018 22.4457 21.018 22.146C21.018 21.8371 20.7855 21.5915 20.5018 21.5915H19.868C18.8943 21.5915 18.1018 20.7545 18.1018 19.726C18.1018 18.8005 18.733 18.0401 19.5605 17.8843V17.1912C19.5605 16.8268 19.8405 16.5311 20.1855 16.5311C20.5305 16.5311 20.8105 16.8268 20.8105 17.1912V17.8513H21.6443C21.9893 17.8513 22.2693 18.147 22.2693 18.5114C22.2693 18.8758 21.9893 19.1715 21.6443 19.1715H19.8693C19.5843 19.1715 19.353 19.4171 19.353 19.7168C19.3518 20.0257 19.5843 20.2713 19.8693 20.2713ZM12.4768 13.8906C11.213 13.8906 10.1855 14.9758 10.1855 16.3106V25.5522C10.1855 26.8869 11.213 27.9721 12.4768 27.9721H27.893C29.158 27.9721 30.1855 26.8869 30.1855 25.5522V16.3106C30.1855 14.9758 29.158 13.8906 27.8943 13.8906H12.4768Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28983_23765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBusinessLoan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_business_loan.9cdc7ecaac7c2e787b0f058e2075e29c.svg";